module.exports = __webpack_public_path__ + "static/media/bonus-report-icon.c84dc744.svg";